import React from "react";
import { IndigoTick } from "./svgs/svg";

export default function Tab(props) {
  return (
    <>
      {props.current === false && props.completed === false ? (
        <div className="flex items-center gap-[10px]">
          <div className="flex items-center gap-x-1">
            {props.num != "1" && <hr className="w-8 bg-[#BFBFBF]" />}
            {/* Number circle */}
            <div className="flex-none w-[24px] h-[24px]  border border-solid border-[#BFBFBF] text-[#BFBFBF] flex justify-center items-center rounded-full">
              <span>{props.num}</span>
            </div>

            {/* Text */}
            <p class="text-xs font-normal whitespace-nowrap leading-4.5 text-left text-[#BFBFBF]">
              {props.label}
            </p>
          </div>
        </div>
      ) : props.current === false && props.completed === true ? (
        <div className="flex items-center gap-[10px] gap-x-1">
          <div className="flex gap-x-1 items-center">
            {props.num !== "1" && <hr className="w-8 bg-[#BFBFBF]" />}
            {/* Number circle */}
            <IndigoTick />

            {/* Text */}
            <p class="text-xs font-normal rounded-2xl whitespace-nowrap leading-4.5 text-left text-[#FFF] py-2 px-4 bg-[#5843BD]">
              {props.label}
            </p>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-[10px]">
          <div className="flex items-center gap-x-1">
            {props.num !== "1" && <hr className="w-8 bg-[#BFBFBF]" />}
            {/* Number circle */}
            <div className="flex-none w-[24px] h-[24px]  bg-[#00000040] text-[#FFF] flex justify-center items-center rounded-full">
              <span>{props.num}</span>
            </div>

            {/* Text */}
            <p class="text-xs font-normal rounded-2xl whitespace-nowrap leading-4.5 text-left text-[#5843BD] py-2 px-4 bg-[#5843BD1A]">
              {props.label}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
